import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    content: {},
    title: {
        padding: theme.spacing(4),
        textAlign: "center",
    },
    warningTextWrapper: {
        marginBottom: theme.spacing(4),
        textAlign: "center",
    },
    warningText: {
        color: theme.palette.error.main,
        fontWeight: "bold !important",
        fontFamily: "Open Sans !important",
        fontSize: "24px !important",
        padding: `0px ${theme.spacing(8)}`,
    },
    hmiCodeWrapper: {
        textAlign: "center",
        marginTop: theme.spacing(8),

        backgroundColor: theme.palette.info.main,
    },
    hmiCode: {
        fontSize: "112px",
        fontWeight: "bold",
        fontFamily: "Open Sans",
        color: theme.palette.primary.main,
    },
    complementedTextWrapper: {
        padding: theme.spacing(4),
        textAlign: "center",
    },
    labelPreview: {
        fontFamily: "Open Sans",
        fontSize: "12px",
        padding: theme.spacing(8),
    },
    printPreviewWrapper: {},
    hmiCodeWrapperPrintPreview: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.palette.corporateBO.buttonLineDivider,
        padding: theme.spacing(4),
    },
    hmiCodeTableWrapperPrintPreview: {
        height: "100%",
        padding: theme.spacing(3),
        borderRadius: 5,
        boxShadow: "0 4px 6px 0 rgba(0, 0, 0, 0.2)",
        position: "relative",
        backgroundColor: theme.palette.primary.main,
        "&:after": {
            position: "absolute",
            content: "''",
            height: 22,
            right: -12,
            borderRadius: 40,
            zIndex: 1,
            top: 70,
            backgroundColor: theme.palette.corporateBO.buttonLineDivider,
            width: 22,
        },
        "&:before": {
            position: "absolute",
            content: "''",
            height: 22,
            left: -12,
            borderRadius: 40,
            zIndex: 1,
            top: 70,
            backgroundColor: theme.palette.corporateBO.buttonLineDivider,
            width: 22,
        },
        "& table": {
            width: "100%",
            height: "100%",
            borderCollapse: "collapse",
            "& th, td": {
                fontFamily: "Aldrich !important",
                fontSize: "14px",
                border: "2px solid black",
            },
            "& td": {
                padding: `0px ${theme.spacing(2)}`,
                backgroundColor: theme.palette.primary.main,
                "&:first-child": {
                    textAlign: "right",
                    color: theme.palette.primary.main,
                    backgroundColor: theme.palette.hmiCodePrintPreview.backgroundColor,
                },
            },
        },
    },
    hmiCodeFieldsPrintPreview: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        padding: theme.spacing(4),
        gap: theme.spacing(2),
    },
    firstTdPreview: {
        textAlign: "right",
        color: theme.palette.primary.main,
        backgroundColor: `${theme.palette.hmiCodePrintPreview.backgroundColor} !important`,
    },
    tableLogoWrapperPreview: {
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& img": {
            width: "100%",
            height: theme.spacing(32),
            objectFit: "contain",
        },
    },
    hmiCodeWrapperPrint: {
        display: "none",
        borderRadius: theme.spacing(1),
        justifyContent: "center",
        alignItems: "center",
        "@media print": {
            marginTop: theme.spacing(12),
            display: "flex",
        },
    },
    tableLogo: {
        height: "100%",
        backgroundColor: `${theme.palette.primary.main} !important`,
    },
    tableLogoWrapper: {
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& img": {
            width: "100%",
            height: "calc(41mm - 10px)",
            objectFit: "contain",
        },
    },
    firstTd: {
        textAlign: "right",
        color: theme.palette.primary.main,
        backgroundColor: `${theme.palette.hmiCodePrintPreview.backgroundColor} !important`,
    },
    hmiCodeTablePrintWrapper: {
        width: "167mm",
        height: "41mm",
        "& table": {
            width: "100%",
            height: "100%",
            borderCollapse: "collapse",
            "& th, td": {
                fontFamily: "Aldrich !important",
                fontSize: "16px",
                border: "2px solid black",
            },
            "& td": {
                padding: `0px ${theme.spacing(2)}`,
                fontFamily: "Open Sans",
                "&:first-child": {
                    textAlign: "right",
                    color: theme.palette.primary.main,
                    backgroundColor: theme.palette.hmiCodePrintPreview.backgroundColor,
                },
            },
        },
    },
    footer: {
        padding: theme.spacing(4),
        display: "flex",
        justifyContent: "flex-end",
        gap: theme.spacing(2),
    },
    printButton: {
        "&.MuiButton-root": {
            fontFamily: "Open Sans !important",
            fontSize: "12px !important",
            fontWeight: "700 !important",
        },
    },
    closeButton: {
        "&.MuiButton-root": {
            fontFamily: "Open Sans !important",
            fontSize: "12px !important",
            fontWeight: "700 !important",
        },
    },
    boxContainer: {
        width: "100%",
    },
    formLabel: {
        "&.MuiTypography-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        "&.MuiFormLabel-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        "&.MuiFormLabel-root.Mui-focused": {
            color: theme.palette.primary.dark,
        },
    },
    textField: {
        width: "100%",

        "& .MuiOutlinedInput-root": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "& .MuiOutlinedInput-input": {
                fontFamily: "Open Sans",
                fontSize: "16px",
                fontWeight: "400",
                padding: `${theme.spacing(2.25)} ${theme.spacing(3)} !important`,
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.main,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
}));

export const modalStyles = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "592px",
    maxHeight: "calc(100vh - 32px)",
    overflowY: "auto",
    bgcolor: "background.paper",
    borderRadius: "4px",
};
